/* eslint-disable quotes */
import { defineComponent, h } from 'vue';
import { Dialog } from '@phi/components';
import { uid_proceed_with_loading_onshape_partstudio_body_details_model } from '@frontend/input_output';

const body = `<div class='row'>
    <div class='col-sm-12 block-3-box wow fadeInUp'>
        <p class='modal-body-text' id='proceed-with-import-text'><p>
    </div>
</div>

<input type='hidden' id='proceedWithImportModal_as_reference' name='as_reference' value='0'>
<input type='hidden' id='proceedWithImportModal_factor' name='factor' value='0'>`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': x => this.$emit('update:show', x),
            close_label: 'Cancel',
            onClose: () => this.$emit('update:show', false),
            confirm_label: 'Proceed',
            //@ts-ignore
            onConfirm: () => uid_proceed_with_loading_onshape_partstudio_body_details_model(),
            id: 'proceedWithImportModal',
            title: 'Importing model',
            unload: false,
            width: 'narrower',
        }, () => h('div', { innerHTML: body }));
    }
});
